const EXPORT_NODE_ATTR = 'data-print-export-node';

function injectExportStyles(doc, { colorMode = 'blackAndWhite' } = {}) {
  const forceBlackAndWhite = colorMode !== 'color';
  const style = doc.createElement('style');
  style.textContent = `
    ${forceBlackAndWhite ? `
      .recipe-print-label--export,
      .recipe-print-label--export * {
        color: #000000 !important;
        border-color: #000000 !important;
        text-shadow: none !important;
        box-shadow: none !important;
      }
    ` : `
      .recipe-print-label--export,
      .recipe-print-label--export * {
        text-shadow: none !important;
      }
    `}

    .recipe-print-label--export {
      background: #ffffff !important;
      box-shadow: none !important;
      -webkit-font-smoothing: none !important;
      text-rendering: geometricPrecision !important;
    }

    ${forceBlackAndWhite ? `
      .recipe-print-label--export .recipe-print-label__nutriscore-letter--active {
        background: #000000 !important;
        color: #ffffff !important;
      }
    ` : ''}
  `;
  doc.head.appendChild(style);
}

export async function downloadElementAsPng(element, fileName, options = {}) {
  if (!element) {
    throw new Error('Element is required for PNG export');
  }

  const { colorMode = 'blackAndWhite', ...html2canvasOptions } = options;
  const { default: html2canvas } = await import('html2canvas');
  element.setAttribute(EXPORT_NODE_ATTR, 'true');

  let canvas;
  try {
    canvas = await html2canvas(element, {
      scale: 5,
      backgroundColor: '#ffffff',
      logging: false,
      useCORS: true,
      imageTimeout: 0,
      onclone: (doc) => {
        injectExportStyles(doc, { colorMode });

        const clonedElement = doc.querySelector(`[${EXPORT_NODE_ATTR}="true"]`);
        if (clonedElement) {
          clonedElement.classList.add('recipe-print-label--export');
        }
      },
      ...html2canvasOptions,
    });
  } finally {
    element.removeAttribute(EXPORT_NODE_ATTR);
  }

  const link = document.createElement('a');
  link.download = fileName;
  link.href = canvas.toDataURL('image/png');
  link.click();
}
